<div class="container-fluid">
  <h4>{{'Reports.header' | translate}}</h4>
  <div class="row mt-4">
    <mat-form-field
      class="{{service.currentUser.userRole === adminRoleName ? 'col-lg-11 col-md-10 col-sm-9' : 'col-12'}}">
      <mat-label>{{'Reports.lblReport' | translate}}</mat-label>
      <mat-select name="market">
        @for (report of reports; track report) {
          <mat-option [value]="report.id" (click)="OnChangeReport(report.id)">
            {{report.value}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (service.currentUser.userRole === adminRoleName) {
      <div class="col-lg-1 col-md-2 col-sm-3 col-12">
        <button class="matbtnNew" mat-raised-button (click)="OnCreateReport()"> {{'btnNew' | translate}} </button>
      </div>
    }
  </div>
  @if (isSelectedReport) {
    <div [@slider]="isSelectedReport? 'show' : null" class="slider{{service.currentUser.userRole !== adminRoleName ? ' hideTabs' : ''}}">
      <mat-tab-group selectedIndex="{{outerTabGroupSelectedIndex}}" dynamicHeight mat-align-tabs="start" mat-stretch-tabs="false" mat-stretch-tabs="false"
        mat-stretch-tabs="false" animationDuration="1000ms">
        @if (selectedReportProperties.columns.length > 0) {
          <mat-tab label="{{'Reports.lblTabGenerate' | translate}}">
            <div class="row">
              <div class="col-lg-6 col-sm-12">
                <div class="col-12">
                  <mat-form-field class="col-6" style="padding-left: 0px;">
                    <mat-label>{{'Reports.lblDateFrom' | translate}}</mat-label>
                    <input matInput [matDatepicker]="dp1" readonly [(ngModel)]="searchParameters.dateFrom"
                      [ngModelOptions]="{standalone: true}">
                      <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                      <mat-datepicker #dp1 disabled="false"></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="col-6" style="padding-right: 0px;">
                      <mat-label>{{'Reports.lblDateTo' | translate}}</mat-label>
                      <input matInput [matDatepicker]="dp2" readonly [(ngModel)]="searchParameters.dateTo"
                        [ngModelOptions]="{standalone: true}">
                        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                        <mat-datepicker #dp2 disabled="false"></mat-datepicker>
                      </mat-form-field>
                    </div>
                    @if (selectedReportProperties.hasMarkets) {
                      <mat-form-field class="col-12">
                        <mat-label>{{'Reports.lblMarkets' | translate}}</mat-label>
                        <mat-select [(ngModel)]="searchParameters.selectedMarket" [ngModelOptions]="{standalone: true}" required>
                          @for (market of lists.markets; track market) {
                            <mat-option [value]="market.id"
                              (click)="OnChangeMarket(market.id)">
                              {{market.value}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (selectedReportProperties.hasInstruments) {
                      <mat-form-field class="col-12">
                        <mat-label>{{'Reports.lblInstruments' | translate}}</mat-label>
                        <mat-select [(ngModel)]="searchParameters.selectedInstrument" [ngModelOptions]="{standalone: true}"
                          required>
                          <mat-option value="all">All</mat-option>
                          @for (instrument of lists.instruments; track instrument) {
                            <mat-option [value]="instrument.id">
                              {{instrument.value}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (selectedReportProperties.hasAccounts && canChangeAccount) {
                      <mat-form-field class="col-12">
                        <mat-label>{{'Reports.lblAccount' | translate}}</mat-label>
                        <mat-select [(ngModel)]="searchParameters.selectedAccount" [ngModelOptions]="{standalone: true}" required>
                          <mat-option value="all">All</mat-option>
                          @for (account of lists.accounts; track account) {
                            <mat-option [value]="account.id">
                              {{account.value}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </div>
                  <div class="col-lg-6 col-sm-12">
                    @if (selectedReportProperties.columns.length > 0) {
                      <div class="col-12">
                        @for (column of selectedReportProperties.columns; track column) {
                          <mat-checkbox class="col-sm-6 col-12"
                            [(ngModel)]="column.enabled" [ngModelOptions]="{standalone: true}" color="primary">
                            {{column.name}}
                          </mat-checkbox>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-12">
                    <button mat-raised-button style="float: right;" color="primary" type="button"
                      (click)="OnClickReport()">
                      {{'Reports.btnReport' | translate}}
                    </button>
                  </div>
                </div>
              </mat-tab>
            }
            @if (service.currentUser.userRole === adminRoleName) {
              <mat-tab label="{{'Reports.lblTabModify' | translate}}">
                <mat-tab-group selectedIndex="{{innerTabGroupSelectedIndex}}" dynamicHeight mat-align-tabs="start" mat-stretch-tabs="false"
                  animationDuration="1000ms">
                  <mat-tab label="{{'Reports.lblTabSQL' | translate}}">
                    <div class="mt-1 row">
                      <div class="col-6">
                        <mat-form-field class="col-12">
                          <mat-label>{{'Reports.lblTables' | translate}}</mat-label>
                          <mat-select>
                            @for (table of tableList; track table) {
                              <mat-option [value]="table"
                                (click)="OnSelectedValueChange(table, 0)">
                                {{table}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-12">
                          <mat-label>{{'Reports.lblColumns' | translate}}</mat-label>
                          <mat-select>
                            @for (column of columnList; track column) {
                              <mat-option [value]="column.name"
                                (click)="OnSelectedValueChange(column.value, 1)">
                                {{column.name}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-6">
                        @if (sqlColumn !== '') {
                          <mat-form-field class="col-12 slider"
                            [@slider]="sqlColumn !== ''? 'show' : null">
                            <mat-label>{{'Reports.lblSqlCol' | translate}}</mat-label>
                            <input matInput type="text" class="cursorChange" value="{{sqlColumn}}" readonly="readonly"
                              onmousemove="this.select()" />
                            </mat-form-field>
                          }
                        </div>
                      </div>
                      <ngx-codemirror #codeMirror [(ngModel)]="selectedReportProperties.sqlQuery" [options]="{
                lineNumbers: true,
                mode: 'text/x-mssql',
                autoRefresh: true,
                lineWrapping : false,
                styleActiveLine: true,
                fixedGutter: true,
                coverGutterNextToScrollbar: false,
                extraKeys: { 'Ctrl-Space': 'autocomplete' },
                showHint: true,
                hintOptions: hintOptionTables
              }">
                      </ngx-codemirror>
                    </mat-tab>
                    <mat-tab label="{{'Reports.lblTabProperties' | translate}}">
                      <div class="row">
                        <div class="col-9">
                          <div class="row">
                            <mat-form-field class="col-6">
                              <mat-label>{{'Reports.lblReportName' | translate}}</mat-label>
                              <input matInput [(ngModel)]="selectedReportProperties.name" />
                            </mat-form-field>
                            <mat-form-field class="col-6">
                              <mat-label>{{'Reports.lblFieldsetAccess' | translate}}</mat-label>
                              <mat-select multiple [(ngModel)]="selectedReportProperties.accessRoles" [ngModelOptions]="{standalone: true}" (selectionChange)="EnableDisableColumnCheckboxes()">
                                @for (role of lists.roles; track role) {
                                  <span>
                                    @if (role.value != adminRoleName) {
                                      <mat-option [value]="role.id">{{role.value}}</mat-option>
                                    }
                                  </span>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="col-3">
                          <fieldset class="col-12">
                            <legend>{{'Reports.lblFieldsetViews' | translate}}</legend>
                            <div class="mt-1">
                              <mat-checkbox class="col-12" [(ngModel)]="selectedReportProperties.hasMarkets"
                                [ngModelOptions]="{standalone: true}" color="primary" (change)="OnClickMarketCheckBox()">
                                {{'Reports.lblMarkets' | translate}}
                              </mat-checkbox>
                              <mat-checkbox class="col-12" [(ngModel)]="selectedReportProperties.hasInstruments"
                                [ngModelOptions]="{standalone: true}" color="primary"
                                [disabled]="selectedReportProperties.hasMarkets === false">
                                {{'Reports.lblInstruments' |
                                translate}}
                              </mat-checkbox>
                              <mat-checkbox class="col-12" [(ngModel)]="selectedReportProperties.hasAccounts"
                                [ngModelOptions]="{standalone: true}" color="primary">
                                {{'Reports.lblAccount' | translate}}
                              </mat-checkbox>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      <h5>{{'Reports.lblColumns' | translate}}</h5>
                      <div class="mat-elevation-z8">
                        <div class="scrollableTable">
                          <table mat-table [dataSource]="dataSourcePropColumns" matSort matSortActive="columnName"
                            matSortDirection="asc">
                            <ng-container matColumnDef="columnName">
                              <th mat-header-cell *matHeaderCellDef style="width: 20%;">
                                {{'Reports.lblColumns' | translate}}
                              </th>
                              <td mat-cell *matCellDef="let element">{{element.name}}</td>
                            </ng-container>
                            <ng-container matColumnDef="space">
                              <th mat-header-cell *matHeaderCellDef style="width: auto;"> </th>
                              <td mat-cell *matCellDef="let element"></td>
                            </ng-container>
                            @for (role of lists.roles; track role) {
                              <ng-container matColumnDef="{{role.value.toLowerCase()}}">
                                <th mat-header-cell *matHeaderCellDef style="width: 5%; text-align: center;"> {{role.value}} </th>
                                <td mat-cell *matCellDef="let element" style="text-align: center;">
                                  <mat-checkbox color="primary" #ckBox [checked]="element.accessRoles.includes(role.id)" (change)="onChangeColumnRole(element, role, ckBox.checked)"></mat-checkbox>
                                </td>
                              </ng-container>
                            }
                            <ng-container matColumnDef="loading">
                              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                                {{'tblLoading' | translate}}...
                              </th>
                            </ng-container>
                            <ng-container matColumnDef="noData">
                              <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                                {{'Reports.reportResultsNoData' |
                                translate}}...
                              </th>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayColumnsPropColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayColumnsPropColumns;"></tr>
                            <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourcePropColumns!=null}">
                            </tr>
                            <tr mat-footer-row *matFooterRowDef="['noData']"
                            [ngClass]="{'hide':dataSourcePropColumns!=null && columnsLength != 0}"></tr>
                          </table>
                        </div>
                      </div>
                    </mat-tab>
                  </mat-tab-group>
                  <div class="mt-2">
                    <button mat-raised-button style="float: right; margin-left: 10px;" color="primary" type="button" (click)="OnSaveReport()">
                      {{'btnSave' |
                      translate}}
                    </button>
                    <button [disabled]="service.currentUser.userRole === operatorRoleName" mat-raised-button style="float: right;" color="secondary" type="button" (click)="OnDeleteReport()">
                      {{'btnDelete' |
                      translate}}
                    </button>
                  </div>
                </mat-tab>
              }
            </mat-tab-group>
          </div>
        }
      </div>
